import React, { Component } from 'react';
import { connect } from 'dva';
import { Modal, Button, Alert } from 'antd';
import SelectUser from 'nbugs-select-user-result-v4.0';
import RangeSelectUser from 'nbugs-select-user-range-v4.0';
import { getAppCode, eduAppCode } from '../../../utils/utils';
import styles from './index.less';

@connect(({ edit }) => ({
  ...edit,
}))
class PublishModal extends Component {
  componentDidMount() {}

  hideModal = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'edit/saveState',
      payload: { publishModalVisible: false },
    });
  };

  saveArticle = () => {
    const { handleOk } = this.props;
    handleOk('submit');
    this.hideModal();
  };

  renderSelectUser = (selectIdType, selectId) => {
    const type = Number(selectIdType); // 1组织，2标签,3课程年级，4指定人员，5本组织

    const selectUserProps = {
      multiple: true,
      selectType: 'dept',
      strictOrgRel: true,
      showTabList: ['orgRel'],
      selectSignature: selectId,
      isSaveSelectSignature: true,
      requestParams: {
        strictUser: true,
        selectTypeList: ['org_rel'],
      },
    };

    if (type !== 5) {
      if (type === 2) {
        return <RangeSelectUser selectSignature={selectId} key={new Date()} />;
      }
      return <SelectUser key={new Date()} selectUserProps={selectUserProps} />;
    }

    return null;
  };

  render() {
    const { publishModalVisible, values, filesLength, orgType, selectId } = this.props;
    const {
      publishUserName,
      samePermissionsModuleId = '',
      qrCode,
      needPush,
      needDown,
      needUp,
      // selectId,
      selectIdType,
    } = values;
    const remindMessage = {
      '1': '是',
      '0': '否',
    };

    const pushOrUp = {
      '2': '是',
      '1': '是',
      '0': '否',
    };

    return (
      <Modal
        title="提交"
        visible={publishModalVisible}
        className={styles['publish-modal']}
        width={650}
        centered
        maskClosable={false}
        onCancel={this.hideModal}
        footer={[
          <Button onClick={this.hideModal}>取消</Button>,
          <Button type="primary" onClick={() => this.saveArticle('submit')}>
            确认提交
          </Button>,
        ]}
      >
        {needPush === '0' && needDown === '0' && (
          <Alert
            message="文章发布时，同时选择不进行消息提醒且不同步，仅在当前组织更新"
            type="info"
            showIcon
          />
        )}

        {Number(getAppCode()) === 1 && this.renderSelectUser(selectIdType, selectId)}

        <div className="attribute">
          <div className="title">属性</div>
          <div className="attribute-container">
            {publishUserName && (
              <div className="attribute-item">
                <span>发布者：</span>
                <span>{publishUserName || '-'}</span>
              </div>
            )}
            {samePermissionsModuleId && (
              <div className="attribute-item">
                <span>相同权限人：</span>
                <span>已选</span>
              </div>
            )}
            {Number(getAppCode()) === 1 && (
              <div className="attribute-item">
                <span>消息提醒：</span>
                <span>{remindMessage[needPush]}</span>
              </div>
            )}

            {orgType !== 'school' && !eduAppCode[getAppCode()] && (
              <div className="attribute-item">
                <span>文章同步：</span>
                <span>{pushOrUp[needDown]}</span>
              </div>
            )}
            {qrCode === '1' ? (
              <div className="attribute-item">
                <span>文末增加二维码：</span>
                <span>是</span>
              </div>
            ) : null}
            <div className="attribute-item">
              <span>附件数：</span>
              <span>{filesLength}</span>
            </div>
            {Number(getAppCode()) === 1 && (
              <div className="attribute-item">
                <span>上报教育局：</span>
                <span>{pushOrUp[needUp]}</span>
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}
export default PublishModal;
